import update from './update';
import show from './show';

export default {
  namespaced: true,
  modules: {
    update,
    show
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company/index.js